import React from 'react';
import PropTypes from 'prop-types';
import lodashIdentity from 'lodash/fp/identity';

import {
  getIn,
} from 'formik';
import getApplicationFormFields, {
  APPLICATION_FORM_TYPE_RENTER_PROFILE,
} from 'common/householdApplication/applicationFormFields';

const SrApplicationOpenPhotosModalButton = ({
  application,
  additionalDocuments,
  renterProfile,
  onPhotosModalOpenClick,
}) => {
  const formFields = getApplicationFormFields({
    formValues: application,
    formType: APPLICATION_FORM_TYPE_RENTER_PROFILE,
  });

  const photoLinks = formFields
    .filter(({ type }) => type === 'file_single')
    .filter(({ id }) => getIn(application, id))
    .map(({ id }) => getIn(application, id))
    .concat(application.paystubPhotos || [])
    .concat(application.offerLetterFileUrl ? [application.offerLetterFileUrl] : [])
    .concat(application.bankStatementFileUrls || [])
    .concat(application.additionalProofOfIncomePhotos || [])
    .concat(renterProfile.verificationOfEmploymentAdditionalDocuments || [])
    .concat(renterProfile.verificationOfRentalAdditionalDocuments || [])
    .filter(lodashIdentity);

  const esaPetPhotoLinks = application.pets
    .filter(({ isEsa }) => isEsa)
    .map(({ photo }) => photo);

  if (photoLinks.length === 0 && additionalDocuments.length === 0) {
    return null;
  }

  const pdfFiles = additionalDocuments.filter((doc) => doc.toLowerCase().includes('.pdf'));

  return (
    <span
      className='link first'
      onClick={() => onPhotosModalOpenClick({
        photoLinks,
        additionalDocuments: additionalDocuments.filter((doc) => !pdfFiles.includes(doc)),
        pdfFiles,
        esaPetPhotoLinks,
      })}
    >
      Photos
    </span>
  );
};

SrApplicationOpenPhotosModalButton.propTypes = {
  application: PropTypes.object.isRequired,
  renterProfile: PropTypes.object.isRequired,
  additionalDocuments: PropTypes.array.isRequired,
  onPhotosModalOpenClick: PropTypes.func.isRequired,
};

SrApplicationOpenPhotosModalButton.displayButton = 'SrApplicationOpenPhotosModalButton';

export default SrApplicationOpenPhotosModalButton;
